(() => {
  if (window.alphaHomeAdditionsRegistered) return;
  window.alphaHomeAdditionsRegistered = true;
  const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  function init(root=document) {
    root.querySelectorAll('[data-alpha-categories]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized='true';
      const tabs=[...section.querySelectorAll('[role=tab]')];
      const select = tab => {
        tabs.forEach(item => { const active=item===tab; item.setAttribute('aria-selected',String(active)); item.tabIndex=active?0:-1; document.getElementById(item.getAttribute('aria-controls')).hidden=!active; });
      };
      tabs.forEach((tab,index) => {
        tab.addEventListener('click',()=>select(tab));
        tab.addEventListener('keydown',event=> {
          let next=index;
          if(event.key==='ArrowRight')next=(index+1)%tabs.length;
          else if(event.key==='ArrowLeft')next=(index-1+tabs.length)%tabs.length;
          else if(event.key==='Home')next=0;
          else if(event.key==='End')next=tabs.length-1;
          else return;
          event.preventDefault();select(tabs[next]);tabs[next].focus();
        });
      });
      section.addEventListener('shopify:block:select',event=> { const card=event.target.closest('[data-audience]'); const tab=tabs.find(item=>item.dataset.audience===card?.dataset.audience); if(tab)select(tab); });
    });
    root.querySelectorAll('[data-alpha-brands]').forEach(section => {
      if(section.dataset.initialized)return;
      section.dataset.initialized='true';
      const track=section.querySelector('.alpha-brands__track');
      const controls=section.querySelector('.alpha-brands__controls');
      const buttons=[...controls.querySelectorAll('button')];
      const items=[...track.querySelectorAll('.alpha-brands__item')];
      const pagination=()=>{
        const max=Math.max(0,track.scrollWidth-track.clientWidth);
        const first=track.children[0],second=track.children[1];
        const stride=second?second.offsetLeft-first.offsetLeft:track.clientWidth;
        const gap=first?stride-first.offsetWidth:0;
        const step=Math.max(1,Math.floor((track.clientWidth+gap)/stride))*stride;
        const last=Math.ceil(max/step);
        const current=track.scrollLeft>max-2?last:Math.min(last,Math.round(track.scrollLeft/step));
        return {max,step,last,current};
      };
      const update=()=>{
        const {max,last,current}=pagination();
        controls.hidden=max<2;
        buttons[0].disabled=track.scrollLeft<2;
        buttons[1].disabled=track.scrollLeft>max-2;
        section.querySelector('.alpha-brands__status').textContent=`${current+1} / ${last+1}`;
      };
      const updateActive=()=>{
        const trackRect=track.getBoundingClientRect();
        const center=trackRect.left+track.clientWidth/2;
        let active=null,distance=Infinity;
        items.forEach(item=>{
          const rect=item.getBoundingClientRect();
          if(rect.right<=trackRect.left||rect.left>=trackRect.right)return;
          const candidateDistance=Math.abs(rect.left+rect.width/2-center);
          if(candidateDistance<distance){active=item;distance=candidateDistance;}
        });
        items.forEach(item=>item.toggleAttribute('data-alpha-brand-active',item===active));
      };
      const sync=()=>{update();updateActive();};
      buttons.forEach(button=>button.addEventListener('click',()=>{
        const {max,step,last,current}=pagination();
        const target=Math.max(0,Math.min(last,current+Number(button.dataset.brandDirection)));
        track.scrollTo({left:Math.min(max,target*step),behavior:motion()});
      }));
      track.addEventListener('scroll',sync,{passive:true});
      const observer=new ResizeObserver(sync);observer.observe(track);
      section.addEventListener('alpha:unload',()=>observer.disconnect(),{once:true});
      sync();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-alpha-brands]').forEach(section=>section.dispatchEvent(new Event('alpha:unload'))));
})();
